import home from './src/home.vue'

import MonitorEquipmentView from './src/MonitorEquipmentManager/MonitorEquipmentView.vue' //监控/摄像头 设备管理列表页
import MonitorEquipmentInfo from './src/MonitorEquipmentManager/MonitorEquipmentInfo.vue' //监控/摄像头 设备管理详情页

import LightEquipmentView from './src/LightEquipmentManager/LightEquipmentView.vue' //照明设备管理列表页
import LightEquipmentInfo from './src/LightEquipmentManager/LightEquipmentInfo.vue' //照明设备管理详情页

import WaterEquipmentView from './src/WaterEquipmentManager/WaterEquipmentView.vue' //灌溉设备管理列表页
import WaterEquipmentInfo from './src/WaterEquipmentManager/WaterEquipmentInfo.vue' //灌溉设备管理详情页

import FireEquipmentView from './src/FireEquipmentManager/FireEquipmentView.vue' //防火设备管理列表页
import FireEquipmentInfo from './src/FireEquipmentManager/FireEquipmentInfo.vue' //防火设备管理详情页

import RoomEquipmentView from './src/RoomEquipmentManager/RoomEquipmentView.vue' //机房设备管理列表页
import RoomEquipmentInfo from './src/RoomEquipmentManager/RoomEquipmentInfo.vue' //机房设备管理详情页

import WifiEquipmentView from './src/WifiEquipmentManager/WifiEquipmentView.vue' //Wifi设备管理列表页
import WifiEquipmentInfo from './src/WifiEquipmentManager/WifiEquipmentInfo.vue' //Wifi设备管理详情页

import BroadcastEquipmentView from './src/BroadcastEquipmentManager/BroadcastEquipmentView.vue' //广播设备管理列表页
import BroadcastEquipmentInfo from './src/BroadcastEquipmentManager/BroadcastEquipmentInfo.vue' //广播设备管理详情页

import SOSEquipmentView from './src/SOSEquipmentManager/SOSEquipmentView.vue' //广播设备管理列表页
import SOSEquipmentInfo from './src/SOSEquipmentManager/SOSEquipmentInfo.vue' //广播设备管理详情页

import MonitorEquipmentViewNew from './src/MonitorEquipmentManagerNew/MonitorEquipmentViewNew.vue' //监控/摄像头新版 设备管理列表页
import MonitorEquipmentInfoNew from './src/MonitorEquipmentManagerNew/MonitorEquipmentInfoNew.vue' //监控/摄像头新版 设备管理详情页

import envdetectEquipmentView from './src/envdetectEquipmentManager/envdetectEquipmentView.vue' //环境监测设备列表页
import envdetectEquipmentInfo from './src/envdetectEquipmentManager/envdetectEquipmentInfo.vue' //环境监测设备详情页

let views = {
    home,
    MonitorEquipmentView,
    MonitorEquipmentInfo,
    LightEquipmentView,
    LightEquipmentInfo,
    WaterEquipmentView,
    WaterEquipmentInfo,
    FireEquipmentView,
    FireEquipmentInfo,
    RoomEquipmentView,
    RoomEquipmentInfo,
    
    WifiEquipmentView,
    WifiEquipmentInfo,
    BroadcastEquipmentView,
    BroadcastEquipmentInfo,
    SOSEquipmentView,
    SOSEquipmentInfo,
    MonitorEquipmentViewNew,
    MonitorEquipmentInfoNew,
    envdetectEquipmentView,
    envdetectEquipmentInfo
};

export default views;